import React, { useReducer, useState, useMemo } from 'react'
import { Grid, Segment, Form, Header, Input, Divider, Button, Icon, Message } from 'semantic-ui-react'
import InputMask from 'react-input-mask'
import request from 'services/http'
import { finalize, tap } from 'rxjs/operators'
import { useSubscription } from 'utils'
import { DateTime } from 'luxon'
import { toast } from 'react-toastify'
import TabelaExtrato from './TabelaExtrato'

const initialFormValues = {
    restaurante: '01',
    tipoCartao: '',
    status: 0,
    tipoData: 'id_data_venda',
    dataInicio: '01/01/2020',
    dataFim: '01/01/2020',
    turnoInicio: '',
    turnoFim: ''
}

function formReducer(state, action) {
    if ('reset' in action)
        return initialFormValues
    if (!('payload' in action))
        return state
    return { ...state, ...action.payload }
}

export default function FormularioExtrato() {

    const [form, setForm] = useReducer(formReducer, initialFormValues)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [loadingData, setLoadingData] = useState(true)
    const [tiposCartaoOptions, setTiposCartaoOptions] = useState([])
    const [dateId, setDateId] = useState(null)
    const [dados, setDados] = useState([])
    const [statusOptions,] = useState([
        { text: 'Geral', value: 0 },
        { text: 'Em Aberto', value: 1 },
        { text: 'Baixado', value: 2 }
    ])
    const [restOptions,] = useState([
        { text: 'Restaurante Dom Pedro 1', value: '01' },
        { text: 'Restaurante Dom Pedro Atibaia', value: '04' },
        { text: 'Hotel Central', value: '08' },
    ])
    const [turnoOptions,] = useState([
        { text: '01', value: '01' },
        { text: '02', value: '02' },
        { text: '03', value: '03' },
        { text: '04', value: '04' },
        { text: '05', value: '05' },
        { text: '06', value: '06' },
    ])

    //GET TIPOS DE CARTÕES
    const submitTiposCartao$ = useMemo(() => request({
        url: '/conciliacao-cartao/tipos-cartao',
        method: 'GET'
    }).pipe(
        tap(({ response }) => {
            setTiposCartaoOptions(response.data)
        }),
        finalize(() => setLoadingData(false))
    ), [])
    useSubscription(submitTiposCartao$, loadingData)

    //GET RELATÓRIO
    const submitRelatorio$ = useMemo(() => request({
        url: '/conciliacao-cartao/relatorio',
        method: 'GET',
        params: { ...form, ...dateId }
    }).pipe(
        tap(({ response }) => {
            if (response.data.length <= 0) {
                toast.error('Dados não encontrados.')
                return
            } else {
                setDados(response.data)
            }
        }),
        finalize(() => setIsSubmitting(false))
    ), [form, dateId])
    useSubscription(submitRelatorio$, isSubmitting)

    function handleChange(event) {
        let name, value
        [name, value] = [event.target.name, event.target.value]
        setForm({ payload: { [name]: value } })
    }

    function handleChangeRadio(_, value) {
        let name, valueX
        [name, valueX] = [value.name, value.value]
        setForm({ payload: { [name]: valueX } })
    }

    function handleChangeSelect(_, { name, value }) {
        setForm({ payload: { [name]: value } })
    }

    function handleSubmit() {
        if (!(!!form.dataInicio) || !(!!form.dataFim)) {
            toast.error('Por favor, informe as datas corretamente antes de prosseguir.')
            return
        } else {
            if (form.tipoData === 'id_data_tur') {
                if (!(!!form.turnoInicio) || !(!!form.turnoFim)) {
                    toast.error('Por favor, informe os turnos corretamente antes de prosseguir')
                    return
                } else {
                    setDateId({
                        idDataIni: DateTime.fromFormat(form.dataInicio, 'dd/MM/yyyy').toFormat('yyMMdd') + form.turnoInicio,
                        idDataFim: DateTime.fromFormat(form.dataFim, 'dd/MM/yyyy').toFormat('yyMMdd') + form.turnoFim
                    })
                }
            } else {
                setDateId({
                    idDataIni: DateTime.fromFormat(form.dataInicio, 'dd/MM/yyyy').toFormat('yyMMdd'),
                    idDataFim: DateTime.fromFormat(form.dataFim, 'dd/MM/yyyy').toFormat('yyMMdd')
                })
            }
        }
        setIsSubmitting(true)
    }

    return (
        <>
            {dados.length <= 0 ? (
                <div className="col d-flex align-items-center flex-column justify-content-center">
                    <Grid style={{ width: '100%' }} className='justify-content-center'>
                        <Grid.Column style={{ width: '650px' }}>
                            <Segment raised textAlign='left' clearing>
                                <Form size={'tiny'} loading={isSubmitting} onSubmit={handleSubmit}>
                                    <Form.Group widths='equal'>
                                        <Form.Select
                                            label={
                                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Restaurante</Header>
                                            }
                                            options={restOptions}
                                            search
                                            selectOnBlur={false}
                                            placeholder='Selecionar Restaurante'
                                            name='restaurante'
                                            value={form.restaurante}
                                            onChange={handleChangeSelect}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Field width='6'>
                                            <Header floated='left' as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Data</Header>
                                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                                            <Input
                                                children={
                                                    <InputMask mask="99/99/9999" placeholder='Inicial' value={form.dataInicio} name='dataInicio' onChange={handleChange} />
                                                }
                                            />
                                        </Form.Field>
                                        <Form.Select
                                            disabled={form.tipoData === 'id_data_tur' ? false : true}
                                            width='2'
                                            options={turnoOptions}
                                            label={
                                                <Header disabled={form.tipoData === 'id_data_tur' ? false : true} as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Turno</Header>
                                            }
                                            search
                                            selectOnBlur={false}
                                            placeholder='--'
                                            name='turnoInicio'
                                            value={form.turnoInicio}
                                            onChange={handleChangeSelect}
                                        />
                                        <Form.Select
                                            width='8'
                                            label={
                                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Tipo Cartão</Header>
                                            }
                                            options={tiposCartaoOptions && tiposCartaoOptions.map((x, index) => ({ key: index, text: x.descricao, value: x.cod }))}
                                            search
                                            selectOnBlur={false}
                                            placeholder='Todos os Cartões'
                                            name='tipoCartao'
                                            value={form.tipoCartao}
                                            onChange={handleChangeSelect}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Field width='6'>
                                            <Header floated='right' as='h5' style={{ margin: 0, marginBottom: 5, color: 'white' }}>-</Header>
                                            <Input
                                                children={
                                                    <InputMask mask="99/99/9999" placeholder='Final' value={form.dataFim} name='dataFim' onChange={handleChange} />
                                                }
                                            />
                                        </Form.Field>
                                        <Form.Select
                                            disabled={form.tipoData === 'id_data_tur' ? false : true}
                                            width='2'
                                            options={turnoOptions}
                                            label={
                                                <Header disabled={form.tipoData === 'id_data_tur' ? false : true} as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Turno</Header>
                                            }
                                            search
                                            selectOnBlur={false}
                                            placeholder='--'
                                            name='turnoFim'
                                            value={form.turnoFim}
                                            onChange={handleChangeSelect}
                                        />
                                        <Form.Select
                                            width='8'
                                            options={statusOptions}
                                            label={
                                                <Header as='h5' style={{ margin: 0, marginBottom: 5 }} color='orange'>Status</Header>
                                            }
                                            search
                                            selectOnBlur={false}
                                            placeholder='Selecionar Status'
                                            name='status'
                                            value={form.status}
                                            onChange={handleChangeSelect}
                                        />
                                    </Form.Group>
                                    <Header color='orange' style={{ margin: 0, marginBottom: 5 }} as='h5'>Tipo de Data</Header>
                                    <Form.Group inline>
                                        <Form.Radio
                                            label='Data de Venda'
                                            name='tipoData'
                                            value={'id_data_venda'}
                                            checked={form.tipoData === 'id_data_venda'}
                                            onChange={handleChangeRadio}
                                        />
                                        <Form.Radio
                                            label='Data de Caixa'
                                            name='tipoData'
                                            value={'id_data_tur'}
                                            checked={form.tipoData === 'id_data_tur'}
                                            onChange={handleChangeRadio}
                                        />
                                        <Form.Radio
                                            label='Previsão de Pagto'
                                            name='tipoData'
                                            value={'id_prev_pagto'}
                                            checked={form.tipoData === 'id_prev_pagto'}
                                            onChange={handleChangeRadio}
                                        />
                                    </Form.Group>
                                    <Message>
                                        <p>
                                            Obs: A opção de turno é aplicada apenas com a opção "Data de Caixa"
                                        </p>
                                    </Message>
                                    <Divider />
                                    <Button icon floated='left' title='Limpar Campos' type='button' onClick={() => setForm({ reset: true })} >
                                        <Icon name='trash' />
                                    </Button>
                                    <Button disabled={isSubmitting} floated='right' icon labelPosition='left' color='vk'>
                                        <Icon name='arrow right' />
                                        Enviar
                                    </Button>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    </Grid>
                </div>
            ) :
                <TabelaExtrato dados={dados} form={form} setDados={setDados} />
            }
        </>
    )
}